import type { SessionUser } from '@apen/shared';
import { useTrocarEmpresa } from '../../hooks/useEmpresas';
import { useFeedback } from '../Feedback/FeedbackProvider';
import { ApiRequestError } from '../../lib/api';
import s from './AppShell.module.css';

/**
 * Empresa ativa, no topo.
 *
 * Com uma empresa so ele nao aparece: a tela fica igual a de antes do
 * multi-empresa para quem atende um cliente.
 */
export function SeletorEmpresa({ session }: { session: SessionUser | null | undefined }) {
  const trocar = useTrocarEmpresa();
  const feedback = useFeedback();
  const empresas = session?.empresas ?? [];

  if (empresas.length < 2) return null;

  async function escolher(id: number) {
    const nome = empresas.find((e) => e.id === id)?.nome ?? '';
    try {
      await trocar.mutateAsync(id);
      feedback.success('Empresa trocada.', `Agora você está em ${nome}.`);
    } catch (erro) {
      feedback.error(
        'Não foi possível trocar de empresa',
        erro instanceof ApiRequestError ? erro.message : undefined,
      );
    }
  }

  return (
    <label className={s.empresaChip} title="Empresa ativa">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M4 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" />
        <path d="M16 9h2a2 2 0 0 1 2 2v10" />
        <path d="M8 7h4M8 11h4M8 15h4M3 21h18" />
      </svg>
      <span className={s.srOnly}>Empresa ativa</span>
      <select
        className={s.empresaSelect}
        value={session?.empresa_id ?? ''}
        disabled={trocar.isPending}
        onChange={(e) => void escolher(Number(e.target.value))}
      >
        {empresas.map((empresa) => (
          <option key={empresa.id} value={empresa.id}>
            {empresa.nome}
          </option>
        ))}
      </select>
    </label>
  );
}
